

import React, { useEffect, useState } from "react";
import "../../Template/LayoutMain/LayoutMain/Layout.css";
import VerifiedPhotographerTable from "./VerifiedPhotographerTable/VerifiedPhotographerTable";
import UnverifiedPhotographerTable from "./UnverifiedPhotographerTable/UnverifiedPhotographerTable";


const Photographer = () => {
  const [activeTab, setActiveTab] = useState("unverified");
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = sessionStorage.getItem("isSidebarOpen");
    return stored !== null ? JSON.parse(stored) : true;
  });

  

  useEffect(() => {
    const interval = setInterval(() => {
      const stored = sessionStorage.getItem("isSidebarOpen");
      const parsed = stored !== null ? JSON.parse(stored) : true;

      if (parsed !== isSidebarOpen) {
        setIsSidebarOpen(parsed);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [isSidebarOpen]);

  return (
    <div
      className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      style={{ marginTop: "100px" }}
    >
      <div className="page-inner-wrapper">

        <h2 className="page-title">Photographer</h2>

        {/* Tabs */}
        <div className="custom-tabs">
          <div
            className={`tab-item ${activeTab === "unverified" ? "active" : ""}`}
            onClick={() => setActiveTab("unverified")}
          >
            Unverified
          </div>

          <div
            className={`tab-item ${activeTab === "verified" ? "active" : ""}`}
            onClick={() => setActiveTab("verified")}
          >
            Verified
          </div>

          


        </div>


        {/* Table */}
        {activeTab === "verified" && <VerifiedPhotographerTable />}
        {activeTab === "unverified" && <UnverifiedPhotographerTable />}


      </div>
    </div>

  );
};

export default Photographer;
